import React from "react";
import Header from "../../components/header/header";
import Maincarousel from "../../components/carousel/carousel";
import Categories from "../../components/categories/categories";
import Introduce from "../../components/introduce/introduce";
import Featured from "../../components/featured-products/featured";
import ApplePremiumSection from "../../components/premiumproduct/premiumproduct";
import Macbook from "../../components/macbook/macbook";
import Faqs from "../../components/faqs/faqs";
import Footer from "../../components/footer/footer";
import Banner from "../../components/banner/banner";

const Home = () => {
  return (
    <div>
      {/* Header */}
      <Header />

      {/* carousel */}
      <Maincarousel />

      {/* categories */}
      <Categories />

      {/* Intorduce */}
      <Introduce />

      {/* premium product */}
      <ApplePremiumSection />

      {/* Featured Products*/}
      <Featured />

      {/* macbook */}
      <Macbook />

      {/* faqs */}
      <Faqs />

      {/* Banner */}
      <Banner />

      {/* footer */}
      <Footer />
    </div>
  );
};

export default Home;
